import { Box, Divider } from "@mui/material";
import React from "react";

import OverageCapacity from "../StoreProducts/OverageCapacity";
import RemovalOrders from "../StoreProducts/RemovalOrders";
import StrandedInventory from "../StoreProducts/StrandedInventory";
import UtilizationRisk from "../StoreProducts/UtilizationRisk";

const InventoryCapacity = ({ store, marketplace }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
    <UtilizationRisk store={store} marketplace={marketplace} />
    <Divider />
    <StrandedInventory store={store} />
    <Divider />
    <OverageCapacity store={store} />
    <Divider />
    <RemovalOrders store={store} marketplace={marketplace} />
  </Box>
);

export default InventoryCapacity;
